import { Dialog, DialogActions, DialogContent, DialogTitle, Link as MuiLink, Stack, Typography } from '@mui/material';
import { Routes } from 'enums';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;

  handleClose(): void;
}

const CoPilotLicenseExpiredDialog: React.FC<Props> = ({ open, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'} transitionDuration={0}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('copilotLicenseExpiredDialogTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>{t('copilotLicenseExpiredDialogContent1')}</Typography>
          <Typography className={classes.text}>
            <Trans i18nKey={'copilotLicenseExpiredDialogContent2'}>
              Bitte
              <Link className={classes.link} to={Routes.ACCOUNT} target={'_blank'}>
                upgrade deine Lizenz
              </Link>, kaufe eine neue Lizenz
              <Link className={classes.link} to={Routes.UPGRADE} target={'_blank'}>
                hier
              </Link>
              , oder
              <MuiLink className={classes.link} href={'mailto:simon.tschuertz@secret-ai-agent.de'} target={'_blank'}>
                kontaktiere uns
              </MuiLink>
              , wenn du einen speziellen Plan für dich oder dein Unternehmen benötigst.
            </Trans>
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: `linear-gradient(to right, ${theme.palette.warning.main}, ${theme.palette.warning.light})`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  link: {
    fontSize: theme.typography.pxToRem(15),
    textDecoration: 'underline',
    color: theme.palette.primary.main,
    textUnderlineOffset: '4px',
    '&:hover': {
      textDecoration: 'underline',
      color: theme.palette.secondary.main,
    },
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default CoPilotLicenseExpiredDialog;
